import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgrammeService } from 'src/app/services/programme.service';
import { Programme } from 'src/app/models/programme';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';
import { ProgrammeCourse } from 'src/app/models/programmeCourse';

@Component({
  selector: 'app-course-programme',
  templateUrl: './course-programme.component.html',
  styleUrls: ['./course-programme.component.scss']
})
export class CourseProgrammeComponent implements OnInit {
  public myProgrammes: any;
  public programmesLoaded:boolean=false;
  public newProgrammeName:string='';
  public newProgrammeError:string='';
  public newProgramme:Programme=new Programme();
  public newProgrammeCourse:ProgrammeCourse=new ProgrammeCourse();

  constructor(
    public dialogRef: MatDialogRef<CourseProgrammeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _prog: ProgrammeService
  ) { }

  ngOnInit() {
    this.getProgrammes();
  }

  createProgrammeAndAdd(){
    if(!this.newProgramme.name) return this.newProgrammeError='Please enter a Programme name to continue.';
    this.newProgrammeError='';
    this.newProgramme.type='Personal';
    this._prog.createProgramme(this.newProgramme).subscribe(
      res=>{
        this.newProgramme=new Programme(res);
        this.assignCourseToProgramme(this.newProgramme.id);
        this.dialogRef.close(true);
      }
    );
  }

  removeCourseFromProgramme(progId:number){
    this.newProgrammeCourse.programme_id=progId;
    this.newProgrammeCourse.course_id=this.data.course.id;
    this.newProgrammeCourse.course=this.data.course;
    this._prog.deleteCourse(this.newProgrammeCourse).subscribe(
      res=>{
        this.getProgrammes();
      }
    );
  }

  assignCourseToProgramme(progId:number){
    this.newProgrammeCourse.programme_id=progId;
    this.newProgrammeCourse.course_id=this.data.course.id;
    this.newProgrammeCourse.course=this.data.course;
    this._prog.addCourse(this.newProgrammeCourse).subscribe(
      res=>{
        this.getProgrammes();
      }
    );
  };

  cancel(){
    this.newProgrammeError='';
    this.newProgramme.name='';
    this.dialogRef.close(false);
  }

  tagProgrammes(){
    if(!this.myProgrammes) return;
    this.myProgrammes.forEach((prog, index)=>{
      if(prog.courses){
        prog.courses.forEach(course=>{
          if(course.course_id==this.data.course.id) this.myProgrammes[index].courseStatus=true;
        });
      }
    });
  }

  getProgrammes(){
    this._prog.getMyProgrammesLight().subscribe(res=>{
      this.myProgrammes = res;
      this.tagProgrammes();
      this.programmesLoaded=true;
    })
  }

}
